import { BaseListResponse, mapToRequestParams, BaseApiRequestParams, KajikiRequestFactory } from './core'

// GET kajikiDBのデータを取得するリクエスト際の時に必要な情報
export interface GetKajikiDataRequest {
  siteId: number
  page?: number
  perPage?: number
}

// GET kajikiDBのデータを取得するリクエストのうちGETパラメータに載せる情報
interface GetKajikiDataRequestParams {
  page?: number | ''
  perPage?: number | ''
}

// kajikiDBのデータを表すモデル定義
export interface KajikiDbItem {
  protocol: string
  domain: string
  isPublished: boolean
  kajikiId: number
  siteTitle: string
  contentDetailPrefixPath: string
}

export interface GetKajikiDbItemResponse extends BaseListResponse<KajikiDbItem> {
}

/**
 * Mekajikiのエンドポイントのインターフェース
 */
export interface IMekajikiEndpoint {
  // kajikiDBのデータを取得する
  getKajikiData: (request: GetKajikiDataRequest) => Promise<GetKajikiDbItemResponse>
}

/**
 * Mekajikiのエンドポイント
 */
export default class MekajikiEndpoint implements IMekajikiEndpoint {
  /**
   * kajikiDBのデータを取得する
   */
  getKajikiData(request: GetKajikiDataRequest): Promise<GetKajikiDbItemResponse> {
    const baseRequest = Object.assign(<BaseApiRequestParams>{}, request)
    const baseParams = mapToRequestParams(baseRequest)
    const params = Object.assign(<GetKajikiDataRequestParams>{}, baseParams)
    const path = `/kajiki`
    const getRequest = KajikiRequestFactory.getRequest()
    return getRequest.execute<GetKajikiDataRequestParams, GetKajikiDbItemResponse>(path, params)
      .then(response => response.data)
  }
}
